export const supportedLanguages = ['en', 'fr', 'de', 'es', 'pt'] as const;

export type Language = (typeof supportedLanguages)[number];

export const defaultLanguage: Language = 'en';

export interface LanguageOption {
  code: Language;
  labelKey: string;
}

export const languages: LanguageOption[] = [
  { code: 'en', labelKey: 'lang.english' },
  { code: 'fr', labelKey: 'lang.french' },
  { code: 'de', labelKey: 'lang.german' },
  { code: 'es', labelKey: 'lang.spanish' },
  { code: 'pt', labelKey: 'lang.portuguese' },
];

export function isSupportedLanguage(value: string | undefined): value is Language {
  return !!value && (supportedLanguages as readonly string[]).includes(value);
}